import {
  getRequestV2,
  postRequestV2,
  patchRequestV2,
  deleteRequestV2,
} from '../../methods';

const getPastConversations = currentPage =>
  getRequestV2(`conversations/events?filter[state]=past&page=${currentPage}`);

const getUpcomingConversations = currentPage =>
  getRequestV2(
    `conversations/events?filter[state]=upcoming&page=${currentPage}`
  );

const searchGoalsAndKeyResults = (query, teamId, kind) =>
  getRequestV2(
    `conversations/goal_selector?query=${encodeURIComponent(
      query
    )}&kind=${kind}&team_id=${teamId}`
  );

const searchBusinessGoals = ({ query, businessUnitId }) =>
  getRequestV2(
    `conversations/goal_selector?query=${encodeURIComponent(
      query
    )}&kind=business_unit&business_unit_id=${businessUnitId}`
  );

const createConversation = body => postRequestV2('conversations/events', body);

const editConversation = (conversationId, body) =>
  patchRequestV2(`conversations/events/${conversationId}`, body);

const getConversation = conversationId =>
  getRequestV2(`conversations/events/${conversationId}`);

const deactivateConversation = eventId =>
  postRequestV2(`conversations/events/${eventId}/deactivate`, {});

const deleteOneTimeConversation = eventId =>
  deleteRequestV2(`conversations/events/${eventId}`, {});

const completePreparations = conversationId =>
  postRequestV2(
    `conversations/events/${conversationId}/complete_preparations`,
    {}
  );

const skipNextConversationEvent = (conversationId, conversationEvent) =>
  postRequestV2(`conversations/events/${conversationId}/skip_instance`, {
    conversationEvent: {
      ...conversationEvent,
      currentStartsAt: conversationEvent.startsAt,
    },
  });

const conversations = {
  searchBusinessGoals,
  searchGoalsAndKeyResults,
  getPastConversations,
  getUpcomingConversations,
  getConversation,
  createConversation,
  editConversation,
  deactivateConversation,
  skipNextConversationEvent,
  deleteOneTimeConversation,
  completePreparations,
};
export default conversations;
